import { useState, useRef } from 'react';
import { HelpIcon } from './HelpIcon';

export function ImageField({ id, label, value, onChange, error, helpText, required, readOnly, placeholder, allowMultiple }) {
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);
  const images = Array.isArray(value) ? value : (value ? [value] : []);

  const handleFiles = (files) => {
    if (!files) return;
    Array.from(files).forEach(file => {
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const result = e.target.result;
          if (allowMultiple) onChange([...images, result]);
          else onChange(result);
        };
        reader.readAsDataURL(file);
      }
    });
  };

  const removeImage = (index) => {
    const next = images.filter((_, i) => i !== index);
    onChange(allowMultiple ? next : (next[0] || ''));
  };

  return (
    <div className="fw">
      <label className="fl" htmlFor={`field-${id}`}>
        {label}
        {required && <span className="req"> *</span>}
        {helpText && <HelpIcon text={helpText} id={id} />}
      </label>
      <div
        onDragOver={e => { e.preventDefault(); setIsDragging(true); }}
        onDragLeave={() => setIsDragging(false)}
        onDrop={e => { e.preventDefault(); setIsDragging(false); if (!readOnly) handleFiles(e.dataTransfer.files); }}
        onClick={() => !readOnly && fileInputRef.current?.click()}
        style={{ border:`2px dashed ${isDragging ? '#3b82f6' : '#cbd5e1'}`, borderRadius:'12px', padding:'2.5rem 1.5rem', textAlign:'center', cursor:readOnly ? 'default' : 'pointer', background:isDragging ? '#eff6ff' : '#f8fafc', transition:'all 0.3s', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:'0.75rem' }}>
        <input type="file" ref={fileInputRef} style={{ display:'none' }} multiple={allowMultiple} accept="image/*" onChange={e => handleFiles(e.target.files)} disabled={readOnly} />
        <div style={{ fontSize:'1.5rem' }}>{isDragging ? '📥' : '📸'}</div>
        <div style={{ color:'#475569', fontSize:'0.875rem' }}>
          {readOnly ? <span style={{ fontWeight:500 }}>View Only Mode</span>
            : <><span style={{ color:'#3b82f6', fontWeight:600 }}>Click to upload</span> or drag and drop</>}
        </div>
      </div>
      {images.length > 0 && (
        <div style={{ display:'flex', flexWrap:'wrap', gap:'0.5rem', marginTop:'1rem' }}>
          {images.map((img, idx) => (
            <div key={idx} style={{ position:'relative', width:'80px', height:'80px', borderRadius:'4px', overflow:'hidden', border:'1px solid #e2e8f0' }}>
              <img src={img} alt={`Preview ${idx}`} style={{ width:'100%', height:'100%', objectFit:'cover' }} />
              {!readOnly && (
                <button onClick={e => { e.stopPropagation(); removeImage(idx); }} style={{ position:'absolute', top:'2px', right:'2px', background:'rgba(239,68,68,0.8)', color:'#fff', border:'none', borderRadius:'50%', width:'18px', height:'18px', fontSize:'10px', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}>✕</button>
              )}
            </div>
          ))}
        </div>
      )}
      {error && <span className="ferr" role="alert">{error}</span>}
    </div>
  );
}
